import { instance } from '@configs/instance';

const getCurrent = (): Promise<any> => {
  return instance.get(process.env.REACT_APP_API_AUTH + `/api/v1/staff/current`);
};

export default {
  getCurrent,
};
